
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/programa-de-integridade",
      function () {
        return require("private-next-pages/programa-de-integridade/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/programa-de-integridade"])
      });
    }
  